import { linkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {
    css: css`
        text-transform: uppercase;
    `,
}

linkListStyles.titleWrapper = {
    css: css`
        display: none;
    `,
}